import Icon from "@material-ui/icons/DirectionsCar";
import { FC } from "react";
import {
  Create,
  CreateProps,
  Datagrid,
  Edit,
  EditProps,
  Filter,
  List,
  ListProps,
  SelectInput,
  Show,
  ShowProps,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "react-admin";
import CrudBreadcrumb from "../components/CrudBreadcrumb";
import StatusField from "../components/StatusField";
import ToolbarWithoutDelete from "../components/ToolbarWithoutDelete";
import { UserStatus } from "../utils/const";

const ResourceList: FC<ListProps> = (props) => (
  <List
    {...props}
    exporter={false}
    filters={<ListFilter />}
    bulkActionButtons={false}
  >
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="full_name" />
      <TextField source="user.email" label="Email" />
      <TextField source="phone" />
      <StatusField source="user.status" label="Status" />
    </Datagrid>
  </List>
);

const ListFilter: FC<any> = (props) => (
  <Filter {...props}>
    <TextInput source="id" label="ID" />
    <TextInput source="search" label="Full Name" />
    <TextInput source="Phone" label="Phone" />
    <SelectInput
      source="user.status"
      label="Status"
      choices={[
        { id: UserStatus.ACTIVE, name: "Active" },
        { id: UserStatus.INACTIVE, name: "Inactive" },
        { id: UserStatus.PENDING, name: "Pending" },
      ]}
    />
  </Filter>
);

const ResourceShow: FC<ShowProps> = (props) => {
  return (
    <>
      <CrudBreadcrumb
        resourceName={Common.resourceName}
        resourceId={props.id}
        mode="show"
      />
      <Show {...props}>
        <SimpleShowLayout>
          <StatusField source="user.status" label="Status" />
          <TextField source="id" />
          <TextField source="user.email" label="Email" />
          <TextField source="user.chat_user_id" label="Chat Ref ID" />
          <TextField source="full_name" />
          <TextField source="phone" />
        </SimpleShowLayout>
      </Show>
    </>
  );
};

const ResourceEdit: FC<EditProps> = (props) => {
  return (
    <>
      <CrudBreadcrumb
        resourceName={Common.resourceName}
        resourceId={props.id}
        mode="edit"
      />
      <Edit {...props}>
        <SimpleForm redirect="show" toolbar={<ToolbarWithoutDelete />}>
          <TextField source="id" />
          <TextField source="user.email" label="Email" />
          <SelectInput
            source="user.status"
            label="Status"
            choices={[
              { id: UserStatus.ACTIVE, name: "Active" },
              { id: UserStatus.INACTIVE, name: "Inactive" },
              { id: UserStatus.PENDING, name: "Pending" },
            ]}
          />
          <TextInput source="full_name" />
          <TextInput source="password" />
          <TextInput source="phone" inputProps={{ maxlength: 12 }} />
        </SimpleForm>
      </Edit>
    </>
  );
};

const ResourceCreate: FC<CreateProps> = (props) => {
  return (
    <>
      <CrudBreadcrumb
        resourceName={Common.resourceName}
        resourceId={""}
        mode="create"
      />
      <Create {...props}>
        <SimpleForm>
          <TextInput source="user.email" type="email" label="Email" />
          <TextInput source="full_name" />
          <TextInput source="phone" inputProps={{ maxlength: 12 }} />
        </SimpleForm>
      </Create>
    </>
  );
};

const Common = {
  resourceName: "drivers",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: Common.resourceName,
  icon: Icon,
  list: ResourceList,
  show: ResourceShow,
  create: ResourceCreate,
  edit: ResourceEdit,
};
